<template>
    <div>
        <ul class="context-menu" v-bind:id="elementId"  v-on-clickaway="onClickOutside">
            <li class="context-menu__item"
                v-bind:key="index"
                v-for="(option, index) in options"
                v-on:click="optionClicked(option)"
            >
                {{option.name}}
            </li>
        </ul>
    </div>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway';

    export default {

        data: function () {
            return {
                item: null,
                menuWidth: null,
                menuHeight: null
            }
        },
        methods: {
            showMenu: function(event, item) {
                let activeContextMenus = document.getElementsByClassName('context-menu--active');
                if (activeContextMenus) {
                    for (let i=0; i < activeContextMenus.length; i++) {
                        activeContextMenus[i].classList.remove('context-menu--active');
                    }
                }

                this.item = item;
                var menu = document.getElementById(this.elementId);
                if (!menu) {
                    return
                }
                if (!this.menuWidth || !this.menuHeight) {
                    menu.style.visibility = "hidden";
                    menu.style.display = "block";
                    this.menuWidth = menu.offsetWidth;
                    this.menuHeight = menu.offsetHeight;
                    menu.removeAttribute("style");
                }
                if ((this.menuWidth + event.clientX) >= window.innerWidth) {
                    menu.style.left = (event.clientX - this.menuWidth + 2) + "px";
                } else {
                    menu.style.left = (event.clientX - 2) + "px";
                }
                if ((this.menuHeight + event.clientY) >= window.innerHeight) {
                    menu.style.top = (event.clientY - this.menuHeight + 2) + "px";
                } else {
                    menu.style.top = (event.clientY - 2) + "px";
                }
                menu.classList.add('context-menu--active');
            },
            hideContextMenu: function() {
                let element = document.getElementById(this.elementId);
                if (element) {
                    element.classList.remove('context-menu--active');
                }
            },
            onClickOutside: function() {
                this.hideContextMenu();
            },
            optionClicked: function(option) {
                this.hideContextMenu();
                this.$emit('optionClicked', {
                    item: this.item,
                    option: option
                })
            }
        },
        mixins: [
            clickaway
        ],
        props: {
            elementId: {
                type: String,
                required: true
            },
            options: {
                type: Array,
                required: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/elements/ContextMenu.vue